export default function () {
  const productFilterButton = document.querySelector('#product-filter');
  const productFilterContainer = document.querySelector('#product-filter-container');
  const productFilterClose = document.querySelector('#product-filter-close');
  const productFilterShowResults = document.querySelector('#show-results-filter');

  if (!productFilterButton) return;

  const onSlideInEnd = (panel) => {
    return function onslideInTransitionEnd() {
      panel.style.transform = 'translateX(0)';
    };
  };

  const onSlideOutEnd = (panel) => {
    return function onslideInTransitionEnd() {
      panel.style.display = 'none';
      panel.style.transform = 'translateX(100%)';
    };
  };

  const removeAllEventListeners = (panel) => {
    panel.removeEventListener('transitionend', onSlideOutEnd);
    panel.removeEventListener('transitionend', onSlideInEnd);
  };

  const slideIn = (button, panel) => {
    button.classList.add('active');
    button.setAttribute('aria-expanded', 'true');

    panel.style.transform = 'translateX(100%)';
    panel.style.display = 'block';

    setTimeout(() => {
      panel.style.transform = 'translateX(0)';
    }, 1);

    removeAllEventListeners(panel);
    panel.addEventListener('transitionend', onSlideInEnd(panel), { once: true });
  };

  const slideOut = (button, panel) => {
    button.classList.remove('active');
    button.setAttribute('aria-expanded', 'false');

    panel.style.transform = 'translateX(0)';

    setTimeout(() => {
      panel.style.transform = 'translateX(100%)';
    }, 1);

    removeAllEventListeners(panel);
    panel.addEventListener('transitionend', onSlideOutEnd(panel), { once: true });
  };

  if (!productFilterButton.classList.contains('active')) {
    productFilterContainer.style.display = 'none';
  }

  productFilterButton.addEventListener('click', () => {
    if (!productFilterButton.classList.contains('active')) {
      slideIn(productFilterButton, productFilterContainer);
      document.body.classList.add('overflow-hidden');
    }
  });

  productFilterClose.addEventListener('click', () => {
    if (productFilterButton.classList.contains('active')) {
      slideOut(productFilterButton, productFilterContainer);
      document.body.classList.remove('overflow-hidden');
    }
  });

  productFilterShowResults.addEventListener('click', () => {
    if (productFilterButton.classList.contains('active')) {
      slideOut(productFilterButton, productFilterContainer);
      document.body.classList.remove('overflow-hidden');
    }
  });

  productFilterButton.setAttribute('aria-expanded', productFilterButton.classList.contains('active') ? 'true' : 'false');
}

